import React, { useEffect, useState } from "react";
import {
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Checkbox,
  Divider,
  Tooltip,
  Box,
} from "@mui/material";
import {
  ISistemaCompleto,
  useSistemaStorage,
} from "../../../../Storage/SistemaStorage";
import { useUsuarioStorage } from "../../../../Storage/UsuariosStorage";
import { api_login_unico_url } from "../../../../Utils/Urls";
import { SwitchStatement } from "typescript";

export const Sistemas = () => {
  const {
    getSistemasPorUsuario,
    sistemas,
    libera_bloqueia_sistema_por_usuario,
  } = useSistemaStorage();
  const { usuarioFocus } = useUsuarioStorage();

  const [permissoes, setPermissoes] = useState<{ [key: number]: boolean }>({});

  useEffect(() => {
    if (usuarioFocus?.usuario?.id) {
      getSistemasPorUsuario(usuarioFocus.usuario.id);
    }
  }, [usuarioFocus?.usuario?.id]);

  useEffect(() => {
    // Atualiza o estado com os sistemas carregados
    const permissoesIniciais = sistemas.reduce(
      (acc: { [key: number]: boolean }, sistema) => {
        acc[sistema.id] = sistema.liberado_todos || !!sistema.liberado;
        return acc;
      },
      {}
    );
    setPermissoes(permissoesIniciais);
  }, [sistemas]);

  const handleToggle = async (sistema: ISistemaCompleto) => {
    if (sistema.liberado_todos) return; // Impede alteração se for liberado para todos

    await libera_bloqueia_sistema_por_usuario(
      usuarioFocus.usuario.id,
      sistema.id,
      sistema.liberado
    );

    await getSistemasPorUsuario(usuarioFocus.usuario.id);
  };

  return (
    <List>
      {sistemas.map((sistema) => (
        <React.Fragment key={sistema.id}>
          <ListItem
            sx={{ display: "flex", alignItems: "center", py: 2 }} // Maior padding vertical
            secondaryAction={
              <Tooltip
                title={
                  sistema.liberado_todos
                    ? "Liberado para todos os usuários"
                    : ""
                }
              >
                <span>
                  <Checkbox
                    edge="end"
                    checked={!!sistema.liberado || sistema.liberado_todos}
                    onChange={() => handleToggle(sistema)}
                    color="primary"
                    disabled={sistema.liberado_todos} // Bloqueia edição se for liberado para todos
                  />
                </span>
              </Tooltip>
            }
          >
            <ListItemAvatar>
              <Avatar
                src={`${api_login_unico_url}/foto-de-sistema/${sistema.logo}`}
                sx={{ width: 56, height: 56 }} // Aumentei o tamanho da foto
              />
            </ListItemAvatar>
            <Box sx={{ ml: 2 }}>
              <ListItemText
                primary={sistema.titulo}
                secondary={sistema.liberado_todos ? "Liberado para todos" : ""}
              />
            </Box>
          </ListItem>
          <Divider />
        </React.Fragment>
      ))}
    </List>
  );
};
